import { Injectable } from "@angular/core";

import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

import { IInfoCardData, ISearchCriteria } from "@tylertech/tyler-api-types";
import { EditDialogComponent, EditDialogData, InfoCardSearchDialogComponent, InfoCardSearchDialogData } from "../components";

@Injectable()
export class InfoCardDialogService
{
    constructor(private readonly matDialog: MatDialog) { }

    showSearchDialog(criteria: ISearchCriteria<IInfoCardData>): Promise<void>
    {
        const dialogConfig: MatDialogConfig<InfoCardSearchDialogData> = {
            data: { criteria }
        };
        const dialogRef = this.matDialog.open(InfoCardSearchDialogComponent, dialogConfig);

        return dialogRef.afterClosed().toPromise();
    }

    showEditDialog(item: IInfoCardData, addMode: boolean, editComponent?: string): Promise<IInfoCardData>
    {
        const dialogConfig: MatDialogConfig<EditDialogData> = {
            data: {
                item,
                addMode,
                editComponent
            }
        };
        const dialogRef = this.matDialog.open(EditDialogComponent, dialogConfig);

        return dialogRef.afterClosed().toPromise();
    }
}
